import React, { useState } from 'react'

const withState = WrappedComponent => {
  return props => {
    const [joinUrl, setJoinUrl] = useState(false)

    return (
      <WrappedComponent joinUrl={joinUrl} setJoinUrl={setJoinUrl} {...props} />
    )
  }
}

export default withState
